export default "__VITE_ASSET__DHAH4qo$__"